import { GetOffersResult } from '@west-australian-newspapers/subscription-offer-types'
import { Logger } from '@west-australian-newspapers/typescript-log'
import React from 'react'
import { transformOffersResultToPackageOption } from '../../subscription-offers/SubscriptionOffers'
import { ISingleSubscriptionPackage } from '../../user-registration/breach/helpers/BreachWallTypes'
import {
    DescriptionText,
    GoogleOfferListContainer,
    SemiboldText,
    StyledInstructionsTitle,
    StyledSubheading,
    StyledSubscriptionCopyArea,
    StyledSubscriptionCopyTitle,
    StyledTextLink,
    UniOfferInstructionsDescription,
} from '../RegionalsSwgPromoPage/RegionalsSwgPromoPage.styled'
import { SwgCampaignOfferValues } from '../campaigns'

export const getFreeTrialOfferRrmeCampaignValues = (
    log: Logger,
    apiOffers?: GetOffersResult,
): SwgCampaignOfferValues | undefined => {
    const campaignOffers = transformOffersResultToPackageOption(
        'campaigns',
        apiOffers,
    )
    // We need to check if campaignOffers has 'default' key and if it has at least one offer
    // if it doesn't, log a warning as a result of multiple calls and the initial call not having completed yet.
    // The last render will always have at least one offer.
    let freeTrialOffer: ISingleSubscriptionPackage | undefined
    if (
        campaignOffers['free-trial-offer'] &&
        campaignOffers['free-trial-offer'].length > 0
    ) {
        freeTrialOffer = campaignOffers[
            'free-trial-offer'
        ][0] as ISingleSubscriptionPackage
    }
    if (
        !freeTrialOffer?.googleSKU ||
        freeTrialOffer.weeklyPrice === undefined
    ) {
        return undefined
    }

    return {
        isDefault: false,
        creative: 'TW_Subscribe_With_Google_Campaign',
        deal: 'swg-promo',
        type: 'Premium - Inline',
        sku: freeTrialOffer.googleSKU,
        price: {
            weekly: freeTrialOffer.weeklyPrice,
            originalPrice: freeTrialOffer.originalPrice,
            promoPrice: freeTrialOffer.price,
            billingTerms: freeTrialOffer.cancellationMessage,
        },
        BenefitListComponent: (
            <>
                <StyledInstructionsTitle>
                    Try the West for FREE.
                </StyledInstructionsTitle>
                <StyledSubheading>
                    A week of unlimited digital access.
                </StyledSubheading>
                <UniOfferInstructionsDescription>
                    Your 7-day digital free trial gives you access to everything
                    on thewest.com.au, including:
                </UniOfferInstructionsDescription>
                <GoogleOfferListContainer>
                    <li>Breaking local, state and national news;</li>
                    <li>WA’s most experienced journalists and columnists;</li>
                    <li>
                        In-depth analysis of WA Business, Politics, Sports &
                        more;
                    </li>
                    <li>Daily digital edition of The West;</li>
                    <li>
                        Subscriber exclusive newsletters & video content; and
                    </li>
                    <li>Access to download The West App.</li>
                </GoogleOfferListContainer>
                <DescriptionText>
                    Plus, link your subscription to your Google account for fast
                    and easy access to The West content across Google.
                </DescriptionText>
            </>
        ),
        TermsAndConditionsComponent: (
            <StyledSubscriptionCopyArea>
                <StyledSubscriptionCopyTitle>
                    <SemiboldText>
                        Subscribe with Google – Free Trial Subscription Offer
                        Terms.
                    </SemiboldText>
                </StyledSubscriptionCopyTitle>
                With this subscription offer, valid from 01.04.26 to 31.05.26,
                your subscription will be charged at $0.00 per week for the
                first week. After your first week, your subscription will be
                charged at the full price of $8.00 per week. Cancel anytime
                before your 7-day free trial ends, and you will not be charged.
                If you cancel after the 7-day free trial, the minimum term is 4
                weeks, and minimum cost is $32, billed every four weeks. After
                the initial 1-week free trial period, your subscription will
                step up to the full price of $8 per week, billed every 4 weeks.
                First payment of $32 is deducted at the conclusion of the free
                trial period, then every 4 weeks after unless cancelled prior.
                <br />
                To be eligible for this offer you must: (a) be a new subscriber;
                (b) have devices that meet the following minimum technical
                requirements: iOS requirement of 16.0 and Android minimum
                requirement of 7.0. Offers are subject to our standard{' '}
                <StyledTextLink
                    href={
                        'https://subscriber.thewest.com.au/subscription-terms'
                    }
                >
                    Subscription Terms and Conditions
                </StyledTextLink>{' '}
                and the standard{' '}
                <StyledTextLink
                    href={
                        'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=googlepaytos&ldl=en-GB'
                    }
                >
                    Subscribe with Google Terms.
                </StyledTextLink>{' '}
                Payment is by Direct Debit at 4-week intervals in accordance
                with our Direct Debit Agreement, with the first payment payable
                on the last day of your 7-day free trial. See{' '}
                <StyledTextLink
                    href={
                        'https://subscriber.thewest.com.au/subscribe-with-google-faq'
                    }
                >
                    Subscribe with Google with Google FAQs.
                </StyledTextLink>
            </StyledSubscriptionCopyArea>
        ),
        InfoComponent: () => <></>,
    }
}
